/// <reference path="../types/index.d.ts" />

import '../client_forms/boldamerican2/style.css';
import FormStructure from './boldamerican2/form_structure';

export default FormStructure;